import main from './logout.svg';
import active from './logout-filled.svg';
import disabled from './logout-gestalt.svg';

export default { main, active, disabled };
